import { useState, useCallback, useEffect } from "react";

export function useDynamicTableHeight({ rowHeight = 40, headerHeight = 48, footerHeight = 48, reservedSpace = 170, minRows = 5 } = {}) {
  // Calculate page size based on window height
  const getPageSizeFromHeight = useCallback(() => {
    const availableHeight = window.innerHeight - headerHeight - footerHeight - reservedSpace;
    const rows = Math.max(minRows, Math.floor(availableHeight / rowHeight));
    return rows;
  }, [rowHeight, headerHeight, footerHeight, reservedSpace, minRows]);

  const [pageSize, setPageSize] = useState(getPageSizeFromHeight());

  // Calculate dynamic table height based on pageSize
  const getTableHeight = useCallback(() => {
    return headerHeight + pageSize * rowHeight + footerHeight + "px";
  }, [pageSize, rowHeight, headerHeight, footerHeight]);

  // Update pageSize when window resizes
  useEffect(() => {
    const handleResize = () => {
      setPageSize(getPageSizeFromHeight());
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [getPageSizeFromHeight]);

  return { pageSize, getTableHeight };
}
